<template>
    <div style="margin-left:-13px; margin-right:-13px">
        <!-- <div v-if="headerbar" class="row row-table-title" style="margin-left:1px; margin-right:1px">
            <div class="col-12 margin-tb section-title dark-green-title" style="padding-top:0px; padding-bottom:0px; ">
                <div class="pull-left">
                    <h2 class="white-font row-table-font-margins" style='font-size:20px; font-family: inherit; font-weight: 400 ; line-height: 1'>Expenses</h2>
                </div>
                <div class="pull-right" style="display: inline-flex;">
                    <expense-form-link v-if="isAdmin" :component="component" :building-id="buildingId" class="test" href="#" data-toggle="tooltip" data-placement="top" title="Included in monthly fee">Add monthly Expense</expense-form-link>

                    <additional-expense-form-link v-if="isAdmin" :building-id="buildingId">Add Additional expenses</additional-expense-form-link>
                    
                    <a v-if="false" style="float:right;color:white;font-size: 14px;" @click.prevent="createpdf()">Download</a>

                </div>
            </div>
        </div> -->
        <div class="table-responsive">
            <table id="expenses-table" :ref="expenses" class="table table-condensed">
                <thead >
                    <tr>
                        <th style="width:22%" scope="col">Expenses</th>
                        <th v-bind:class="{'active-month': currentMonth == 1}"  style="width:6%;text-align:center" scope="col">Jan</th>
                        <th v-bind:class="{'active-month': currentMonth == 2}"  style="width:6%;text-align:center" scope="col">Feb</th>
                        <th v-bind:class="{'active-month': currentMonth == 3}"  style="width:6%;text-align:center" scope="col">Mar</th>
                        <th v-bind:class="{'active-month': currentMonth == 4}"  style="width:6%;text-align:center" scope="col">Apr</th>
                        <th v-bind:class="{'active-month': currentMonth == 5}"  style="width:6%;text-align:center" scope="col">May</th>
                        <th v-bind:class="{'active-month': currentMonth == 6}"  style="width:6%;text-align:center" scope="col">Jun</th>
                        <th v-bind:class="{'active-month': currentMonth == 7}"  style="width:6%;text-align:center" scope="col">Jul</th>
                        <th v-bind:class="{'active-month': currentMonth == 8}"  style="width:6%;text-align:center" scope="col">Aug</th>
                        <th v-bind:class="{'active-month': currentMonth == 9}"  style="width:6%;text-align:center" scope="col">Sep</th>
                        <th v-bind:class="{'active-month': currentMonth == 10}" style="width:6%;text-align:center" scope="col">Oct</th>
                        <th v-bind:class="{'active-month': currentMonth == 11}" style="width:6%;text-align:center" scope="col">Nov</th>
                        <th v-bind:class="{'active-month': currentMonth == 12}" style="width:6%;text-align:center" scope="col">Dec</th>
                        <th style="width:6%;text-align:center" scope="col">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="clickable-row" v-for="expenseFee in getExpenses" :key="expenseFee">
                        <td class="clickable-column" style="cursor: default" scope="row">
                            <div v-tooltip:left="toolTipText">
                                <router-link style="color: #212122;font-weight: normal;" data-toggle="tooltip"
                                             data-placement="top" :title="expenseFee.expenseName" :to="{name:'expensesIndex', params: { expenseId:expenseFee.expenseId, buildingId:buildingId, buildingName:buildingName,expenseName:expenseFee.expenseName,period:period}}">{{ expenseFee.expenseName }}</router-link>
                            </div>

                            
                        </td>
                         <td style="text-align: center; cursor: default" v-bind:class="{'active-month-column': currentMonth == (key2+1)}"  class="clickable-column" v-for="(fee, key2) in expenseFee.fees" :key="fee">
                            <div v-if="key2 < 12">

                                <div v-if="fee == 0">
                                    
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee) }}
                                </div>
                            </div>
                            <div v-else>
                                <strong>
                                    <div v-if="fee == 0">
                                       
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(fee) }}
                                    </div>
                                </strong>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td scope="row">
                            <strong>
                                Total
                            </strong>
                        </td>
                       <td v-bind:class="{'active-month-column': currentMonth == (key3+1)}" style="text-align: center; cursor: default"  v-for="(total, key3) in totalFees" :key="total">
                            <strong>
                                <div v-if="total == 0">
                                   
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(total) }}
                                </div>
                            </strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <modal name="hello-world" @before-open="beforeOpen" height="auto" :minHeight="600">
            <div class="" id="expenseModal" role="dialog">
                <div class="">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" @click="$emit('close')" data-dismiss="modal">&times;</button>
                            <h4 class="modal-title">Add monthly Expense</h4>
                        </div>
                        <div class="modal-body-expense">
                            <div class="row" style="padding:5px">
                                <expense-form :createpdf="createpdf" :building-id="buildingId" :expense-type-id="expenseTypeId" :month-prop="monthParam"></expense-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
$(document).ready(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";

export default {
  props: ["buildingId", "route", "period", "filter", "component", "headerbar"],
  data: function () {
    return {
        expenseFees: [],
        creditNoteFees: [],
      totalFees: [],
      index: 0,
      isModalVisible: true,
      expenseTypeId: 0,
        monthParam: 0,
        currentMonth: 0
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  mounted() {
      if (this.buildingId) this.fetchStatement();
      if (!this.$period.isCurrent(this.period)) {
          this.currentMonth = 12;
          this.year = new Date().getFullYear() - Number(this.period);
      } else {
          this.year = new Date().getFullYear() - 1;
          this.currentMonth = new Date().getMonth() + 1;
      }
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    createpdf() {
      return true;
    },
    beforeOpen(event) {
      this.expenseTypeId = event.params.expensetypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
      alert(this.isModalVisible);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {
      this.mute = true;
      var request = "/expenses/statement";

      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId + "&period=" + this.period;
      /*  if(this.period == 2)
                      request = request +'/'+this.period;
                  else
                      request = request +'?id='+this.buildingId;*/
      this.$http
        .get(request, {
          id: 1,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.expenseFees = data.expenseFees;
            this.totalFees = data.totalFees;
            this.creditNoteFees = data.creditNoteFees;
        });
    },
    showModalTemp: function (expenseId, month) {
      this.$modal.show("hello-world", {
        expensetypeid: expenseId,
        month: month,
      });
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      this.$modal.show("hello-world");
    },
    hide() {
      this.$modal.hide("hello-world");
    },
  },
  computed: {
    toolTipText: function () {
      return "voila!";
    },

    getExpenses() {
      if (this.filter) {
        var expenseFees = this.expenseFees.filter((expenseFee) => {
          return expenseFee.expenseName
            .toLowerCase()
            .includes(this.filter.toLowerCase());
        });

        return expenseFees;
      } else return this.expenseFees;
    },
    total: function () {
      //console.log(this.expenseFees);
      return this.expenseFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
    isAdmin() {
      return (
        this.currentUser &&
        (this.currentUser.role === Role.Admin ||
          this.currentUser.role === Role.Management)
      );
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    //  this.$store.dispatch('users/getAll');
  },
};
// Our Javascript logic
</script>
